import { Star } from "lucide-react";

const TESTIMONIALS = [
    {
        quote: "From a caseworker's perspective, what stands out is the structure and the follow-through. They show up to every meeting prepared, share progress honestly, and keep the youth at the center of every decision.",
        name: "A. Williams, LMSW",
        role: "Social Worker · Harris County",
        initials: "AW",
        accent: "bg-[#0E2A47] text-white",
    },
    {
        quote: "When I got here I didn't trust anybody. The staff didn't try to fix me — they just kept being there. Now I'm finishing high school and helping the new guys settle in.",
        name: "Jordan, 17",
        role: "Program Resident",
        initials: "JM",
        accent: "bg-[#C8A24A] text-[#1A2230]",
    },
    {
        quote: "I've referred several youth. The team there meets boys where they are — they hold them accountable without breaking them down. That balance is rare.",
        name: "Mr. Daniels",
        role: "School Counselor · Tomball ISD",
        initials: "TD",
        accent: "bg-[#7BA37F] text-white",
    },
];

export default function TestimonialsSection() {
    return (
        <section className="py-20 bg-[#EFEBE0]">
            <div className="max-w-6xl mx-auto px-6 md:px-10 lg:px-14">
                <div className="text-center mb-12">
                    <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                        Voices we serve
                    </p>
                    <h2 className="mt-3 font-[Outfit] text-3xl md:text-4xl font-semibold tracking-tight">
                        What families and partners say.
                    </h2>
                    <p className="mt-4 text-[15px] text-[#6F6B63] max-w-2xl mx-auto">
                        Representative voices from the parents, partners
                        and young men we walk alongside. Names and details
                        are anonymized to protect privacy.
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto" data-testid="testimonials-grid">
                    {TESTIMONIALS.map((t, i) => (
                        <div
                            key={t.name}
                            className="bento-card bg-white rounded-2xl p-6 border border-[#E5DFD3] flex flex-col"
                            data-testid={`testimonial-${i}`}
                        >
                            <div className="flex items-center gap-1 mb-3 text-[#C8A24A]">
                                {[1, 2, 3, 4, 5].map((s) => (
                                    <Star key={s} className="h-3.5 w-3.5 fill-current" />
                                ))}
                            </div>
                            <p className="text-[14.5px] text-[#1A2230]/85 leading-relaxed flex-1">
                                &ldquo;{t.quote}&rdquo;
                            </p>
                            <div className="mt-5 pt-5 border-t border-[#E5DFD3] flex items-center gap-3">
                                <span className={`h-10 w-10 rounded-full grid place-items-center font-[Outfit] font-semibold text-[12.5px] ${t.accent}`}>
                                    {t.initials}
                                </span>
                                <div className="leading-tight">
                                    <p className="text-[13.5px] font-[Outfit] font-semibold text-[#1A2230]">
                                        {t.name}
                                    </p>
                                    <p className="text-[11.5px] text-[#6F6B63] uppercase tracking-[0.12em] mt-1">
                                        {t.role}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="text-center mt-10 text-[12px] text-[#6F6B63] italic max-w-2xl mx-auto">
                    These are representative testimonials based on common
                    themes from the families and partners we serve.
                    Identifying details have been changed to protect
                    privacy.
                </p>
            </div>
        </section>
    );
}
